module.exports = __webpack_public_path__ + "media/images/heart-176d85db618a3d4c1d69d5a152587df1.png";